module.exports = __webpack_public_path__ + "img/contactBg.03c7fbe9.png";